import * as actionTypes from './types';

const inituelState = {
    loading: false,
    error: false,
    
    languages: null
};
const languagesReducer = (state = { ...inituelState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.REQUST_LANGUGES:
            return {
                ...state,
                loading: true
            };
        case actionTypes.FAILED_LANGUGES:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case actionTypes.SUCCESS_LANGUGES:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false
            };

      
        default:
            return {
                ...state
            };
    }
};

export default languagesReducer;
